module.exports = __webpack_public_path__ + "img/sup_register_1.9e5cbfbd.png";